import { BaseBusinessService } from "./base-business-service.ts"
import { OrganizationServiceInterface } from "interfaces/organization-service.ts"

export class BusinessOrganizationService
    extends BaseBusinessService
    implements OrganizationServiceInterface
{
    useGetOrganization = (opts?: {
        include_children?: boolean
        depth?: number
    }) => {
        const { include_children = true, depth = 3 } = opts ?? {}

        const params = new URLSearchParams()
        if (opts?.include_children !== undefined) {
            params.set("include_children", String(include_children))
        }
        if (opts?.depth !== undefined) {
            params.set("depth", String(depth))
        }

        const qs = params.toString()
        const endpoint = `${qs ? `?${qs}` : ""}`

        return this.get({ endpoint })
    }

    useGetEnableMultiOrganization() {
        return this.get({ endpoint: "/enable-multi-organization" })
    }
}
